/*
 *app.settings.js
 *Copyright (c) 2016 Westat Inc.
 */
export const appSettings = {
ADCM: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: true,
			AssignmentCode: false
		}
	}
},
ANES: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: true,
			AssignmentCode: false
		}
	}
},
CBECS: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: false,
			showRegion: true,
			showSegment: false,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnLabels: {
				duidLabel: "BID"
			},
			columnValues: {
				spidNoDataValue: ""
			}
		},
		byStaff: {
			showRegion: true,
			showSegment: true,
			columnLabels: {
				duidLabel: "BID"
			},
			columnValues: {
				spidNoDataValue: ""
			}
		},
		byManager: {
			showRegion: true,
			showSegment: true,
			columnLabels: {
				duidLabel: "BID"
			},
			columnValues: {
				spidNoDataValue: ""
			}
		},
		bySPID: {
			showView: false,
			columnValues: {
				spidNoDataValue: ""
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: false,
			AssignmentCode: false,
			columnLabels: {
				duidLabel: "BID"
			}
		}
	},
	map: {
		taskPopup: {
			showTaskType: false,
			showDispositionCode: false,
			showRegion: true,
			showSegment: false,
			showWave: false,
			popupColumnLabels: {
				duidLabel: "BID"
			},
			popupColumnValues: {}
		},
		addressPopup: {
			showRegion: false,
			popupColumnLabels: {},
			popupColumnValues: {}
		}
	},
	ACE: {
		aceTaskList: {
			showTaskStatus: false
		},
		taskPopup: {
			popupRows: {
				showTaskLabel: false,
				showDispositionCode: false,
				showDispositionLabel: false,
				showGeocodedAddress: false,
				showGeoMatch: false,
				showWave: false,
				showLocatedBuildingName: true
			},
			popupRowColumnValues: {
				TaskTypeValue: "Listing"
			},
			popupRowColumnLabels: {
				LocatedAddressLabel: "Listed Address"
			}
		}
	}
},
ISAS: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: true,
			AssignmentCode: false
		}
	}
},
MEPS: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: false,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: false,
			showSPID: true,
			AssignmentCode: false
		}
	},
	map: {
		taskPopup: {
			showTaskType: false,
			showDispositionCode: true,
			showRegion: false,
			showSegment: false,
			showWave: false,
			popupColumnLabels: {},
			popupColumnValues: {}
		},
		addressPopup: {
			showRegion: false,
			popupColumnLabels: {},
			popupColumnValues: {}
		}
	}
},
NHANES: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			showRegion: false,
			columnLabels: {
				psuLabel: "Stand"
			},
			columnValues: {
				spidNoDataValue: ""
			}
		},
		byStaff: {
			showRegion: false,
			columnLabels: {
				psuLabel: "Stand"
			},
			columnValues: {
				spidNoDataValue: ""
			}
		},
		byManager: {
			showRegion: false,
			columnLabels: {
				psuLabel: "Stand"
			},
			columnValues: {
				spidNoDataValue: ""
			}
		},
		bySPID: {
			columnLabels: {
				psuLabel: "Stand"
			},
			columnValues: {
				spidNoDataValue: ""
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: true,
			AssignmentCode: false,
			columnLabels: {},
			columnValues: {
				spidNoDataValue: ""
			}
		},
		routeView: {
			columnLabels: {},
			columnValues: {
				spidNoDataValue: ""
			}
		},
		daySummary: {
			showManager: false,
			columnLabels: {
				supervisorLabel: "Study Manager"
			},
			columnValues: {}
		},
		map: {
			taskPopup: {
				showTaskType: false,
				showDispositionCode: false,
				showRegion: false,
				showSegment: false,
				showWave: false,
				popupColumnLabels: {
					psuLabel: "Stand"
				},
				popupColumnValues: {}
			},
			addressPopup: {
				showRegion: false,
				popupColumnLabels: {},
				popupColumnValues: {}
			}
		}
	}
},
NHATS: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: false,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: false,
			showSPID: true,
			AssignmentCode: false
		}
	}
},
NOPUS: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: true,
			AssignmentCode: false
		}
	}
},
NSCS: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnLabels: {
				duidLabel: "DUID"
			},
			columnValues: {
				spidNoDataValue: "No ID"
			}
		},
		byStaff: {
			showRegion: true,
			showSegment: true,
			columnLabels: {
				duidLabel: "DUID"
			},
			columnValues: {
				spidNoDataValue: "No ID"
			}
		},
		byManager: {
			showRegion: true,
			showSegment: true,
			columnLabels: {
				duidLabel: "DUID"
			},
			columnValues: {
				spidNoDataValue: "No ID"
			}
		},
		bySPID: {
			showView: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: true,
			AssignmentCode: false
		}
	}
},
PAC20: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: false,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: false,
			showSPID: true,
			AssignmentCode: false
		}
	},
	map: {
		taskPopup: {
			showTaskType: false,
			showDispositionCode: true,
			showRegion: false,
			showSegment: false,
			showWave: false,
			popupColumnLabels: {},
			popupColumnValues: {}
		},
		addressPopup: {
			showRegion: false,
			popupColumnLabels: {},
			popupColumnValues: {}
		}
	}
},
PATH: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: true,
			AssignmentCode: false
		}
	}
},
PIAAC: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: true,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: true,
			showSPID: true,
			AssignmentCode: false
		}
	}
},
YEAR22: {
	searchResultsDisplay: {
		byStatus: {
			showDUID: false,
			showSPID: true,
			DateINTERIM: false,
			DateASSIGNED: false,
			DateCREATED: false,
			columnValues: {
				spidNoDataValue: "No ID"
			}
		}
	},
	dayView: {
		taskList: {
			showDUID: false,
			showSPID: true,
			AssignmentCode: false
		}
	},
	map: {
		taskPopup: {
			showTaskType: false,
			showDispositionCode: true,
			showRegion: false,
			showSegment: false,
			showWave: false,
			popupColumnLabels: {},
			popupColumnValues: {}
		},
		addressPopup: {
			showRegion: false,
			popupColumnLabels: {},
			popupColumnValues: {}
		}
	}
}
}
